import { render, staticRenderFns } from "./EditShapesMode.vue?vue&type=template&id=f47cd4cc&scoped=true&"
import script from "./EditShapesMode.vue?vue&type=script&lang=ts&"
export * from "./EditShapesMode.vue?vue&type=script&lang=ts&"
import style0 from "./EditShapesMode.vue?vue&type=style&index=0&id=f47cd4cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47cd4cc",
  null
  
)

export default component.exports